/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction_version_status" */
export enum ArgoWorkInstructionVersionStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ArgoWorkInstructionVersionStatusPkey = 'argo_work_instruction_version_status_pkey'
}

export enum ArgoWorkInstructionVersionStatusEnum {
  Released = 'released',
  Retired = 'retired',
  Staged = 'staged'
}

/** select columns of table "argo.work_instruction_version_status" */
export enum ArgoWorkInstructionVersionStatusSelectColumn {
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.work_instruction_version_status" */
export enum ArgoWorkInstructionVersionStatusUpdateColumn {
  /** column name */
  Status = 'status'
}

